import { Text, TextProps } from "@chakra-ui/react";
import { FrameworkAgreementDto } from "../../autogen/bff-api";
import { useStartRefusal } from "./callOffAvailability";

export const StartRefusalNote = ({
  framework,
  startsMiniCompetition = false,
  ...textProps
}: {
  framework: FrameworkAgreementDto;
  startsMiniCompetition?: boolean;
} & TextProps) => {
  const refusal = useStartRefusal(framework, { startsMiniCompetition });
  if (refusal === null) return null;
  return (
    <Text fontSize="sm" color="smMuted" {...textProps}>
      {refusal}
    </Text>
  );
};
